var map = {
	"./IMAG0114.jpg": 2536,
	"./IMAG0115.jpg": 4901,
	"./IMAG0119.jpg": 3441,
	"./IMAG2449.jpg": 1337,
	"./IMAG2450.jpg": 8451,
	"./IMAG2458.jpg": 6635,
	"./IMAG2462.jpg": 1308,
	"./IMAG2465.jpg": 5095,
	"./IMAG2479.jpg": 1232,
	"./IMAG2481.jpg": 6877,
	"./IMG-20160511-WA0016 - Copy - Copy.jpg": 2768,
	"./IMG_20161019_155511.jpg": 1757,
	"./IMG_20161028_124831.jpg": 1622,
	"./IMG_20161028_124838.jpg": 251,
	"./IMG_20161121_151457.jpg": 1070,
	"./IMG_20161126_115758.jpg": 1403,
	"./IMG_20161206_124656.jpg": 3939,
	"./IMG_20161206_124704.jpg": 5059,
	"./Kenyon-Bespoke-Refrigerated-Cold-Room.jpg": 4954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 679;